export default __webpack_public_path__ + "static/media/Defects.a7436dc1.svg";